import { render, staticRenderFns } from "./ArchiveUpload.vue?vue&type=template&id=5a232d1e&scoped=true&"
import script from "./ArchiveUpload.vue?vue&type=script&lang=js&"
export * from "./ArchiveUpload.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveUpload.vue?vue&type=style&index=0&id=5a232d1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a232d1e",
  null
  
)

export default component.exports